module.exports = __webpack_public_path__ + "media/gym.e0e62ae8.mp4";